export const SiteConfigRoutes = [
  {
    path: '/Admin/SiteConfig/BITestLevel',
    name: '测评等级管理',
    component: () => import('./BITestLevel/index.vue'),
    meta: {
      title: '测评等级管理'
    }
  }, {
    path: '/Admin/SiteConfig/BITestLevelT',
    name: '测评等级管理',
    component: () => import('./BITestLevelT/index.vue'),
    meta: {
      title: '测评等级管理'
    }
  },{
    path: '/Admin/SiteConfig/BITestLevelE',
    name: '测评等级管理',
    component: () => import('./BITestLevelE/index.vue'),
    meta: {
      title: '测评等级管理'
    }
  },{
    path: '/Admin/SiteConfig/ConfigBanner',
    name: '首页轮播图管理',
    component: () => import('./configBanner/index.vue'),
    meta: {
      title: '首页轮播图管理'
    }
  }, {
    path: '/Admin/SiteConfig/ConfigSiteParams',
    name: '站点信息设置',
    component: () => import('./ConfigSiteParams/index.vue'),
    meta: {
      title: '站点信息设置'
    }
  }, {
    path: '/Admin/SiteConfig/BIcourseCate',
    name: '教学分类设置',
    component: () => import('./BIcourseCate/index.vue'),
    meta: {
      title: '教学分类设置'
    }
  },
  {
    path: '/Admin/SiteConfig/INterviewer',
    name: '考官测评提成',
    component: () => import('./INterviewer/index.vue'),
    meta: {
      title: '考官测评提成'
    }
  }
]



// WEBPACK FOOTER //
// ./src/pages/Admin/AdminHome/SiteConfig/routes.js